var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeed/models/dto',["require", "exports"], function (require, exports) {
    "use strict";
    var TokenRequest = (function () {
        function TokenRequest() {
        }
        return TokenRequest;
    }());
    exports.TokenRequest = TokenRequest;
    var Token = (function () {
        function Token() {
        }
        return Token;
    }());
    exports.Token = Token;
    var TokenResponse = (function () {
        function TokenResponse() {
            this.token = new Token();
        }
        return TokenResponse;
    }());
    exports.TokenResponse = TokenResponse;
    var SessionResponse = (function (_super) {
        __extends(SessionResponse, _super);
        function SessionResponse() {
            _super.apply(this, arguments);
        }
        return SessionResponse;
    }(TokenResponse));
    exports.SessionResponse = SessionResponse;
    var OfficeResponse = (function (_super) {
        __extends(OfficeResponse, _super);
        function OfficeResponse() {
            _super.apply(this, arguments);
        }
        return OfficeResponse;
    }(SessionResponse));
    exports.OfficeResponse = OfficeResponse;
    var ClientResponse = (function (_super) {
        __extends(ClientResponse, _super);
        function ClientResponse() {
            _super.apply(this, arguments);
        }
        return ClientResponse;
    }(OfficeResponse));
    exports.ClientResponse = ClientResponse;
    var ActivitiesResponse = (function (_super) {
        __extends(ActivitiesResponse, _super);
        function ActivitiesResponse() {
            _super.apply(this, arguments);
        }
        return ActivitiesResponse;
    }(ClientResponse));
    exports.ActivitiesResponse = ActivitiesResponse;
    var ActivityFeedServiceModel = (function () {
        function ActivityFeedServiceModel() {
        }
        return ActivityFeedServiceModel;
    }());
    exports.ActivityFeedServiceModel = ActivityFeedServiceModel;
});

